<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="lg" :visible="modal.show" :data="model" scrollable
                   :title="$t(`Configure Report`)" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading || initialLoading">
      <spinner :show="initialLoading" v-if="initialLoading"/>
      <div v-else class="row">
        <div class="col-md-4" v-for="filter in filters" :key="`report-configuration-field-${filter.key}`">
          <template v-if="filter.type === 'string'">
            <input-widget :model="model" :attribute="filter.key"/>
          </template>
          <template v-if="filter.type === 'list'">
            <input-widget :model="model" :attribute="filter.key" type="select2" :items="filter.options"
                          value-field="key" display-field="${item.text}"/>
          </template>
          <template v-if="filter.type === 'relational'">
            <template v-if="filter.key === 'customer_uuid'">
              <customer-select-input-widget :model="model" :attribute="filter.key"/>
            </template>
          </template>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import ReportConfigurationModel from "@/modules/reports/ReportConfiguration.model";
  import GeneralLoader from "@/core/components/general-loader/GeneralLoader";
  import ReportsService from "@/modules/reports/ReportsService";
  import Template from "@/modules/setup/templates/Templates";
  import CustomerSelectInputWidget from "@/core/widgets/CustomerSelectInputWidget";
  import CustomerService from "@/modules/customer/CustomerService";
  import Spinner from "@/core/components/common/Spinner";

  const {mapState, mapActions} = createNamespacedHelpers('reports');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "ReportConfigurationModal",
    components: {
      Spinner,
      CustomerSelectInputWidget,
      Template,
      GeneralLoader,
      InputWidget, ArtisioModal
    },
    data() {
      return {
        loading: false,
        initialLoading: false,
        showConfirmation: true,
        model: new ReportConfigurationModel(),
        filters: []
      }
    },
    computed: {
      ...mapState({
        modal: state => state.reportConfigurationModal,
        report: state => state.reportConfigurationModal.report
      }),
      ...globalMapState({
        currentUser: state => state.currentUser
      })
    },
    watch: {
      async report() {
        if (this.report) {
          this.initialLoading = true;
          await this.initializeReportConfigurationModel(
            this.report.available_filters.filter(i => i.required),
            this.report.filter_data
          )
          this.initialLoading = false;
        }
      },
    },
    methods: {
      ...mapActions(['hideReportConfigurationModal', 'getReports']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.filters = [];
        this.model = new ReportConfigurationModel();
        this.hideReportConfigurationModal();
      },
      prepareListFilterOptions(filters) {
        for (let i in filters) {
          if (filters[i].type === 'list') {
            filters[i].options = filters[i].options.map(val => {
              return {
                key: val, text: this.$options.filters.toUpperCaseFirst(val)
              }
            })
          }
        }
      },
      async initializeReportConfigurationModel(filters, filterData) {
        // Convert filter options to objects array instead of strings array
        this.prepareListFilterOptions(filters);

        const relationalFilters = filters.map(item => item.type === 'relational' ? item.key : null).filter(i => i);
        let dataForObj = new ReportConfigurationModel();
        filterData = filterData[this.currentUser.uuid];

        // Initialize model related attributes
        for (let item of filters) {
          dataForObj[item.key] = null;
          dataForObj.attributeLabels[item.key] = item.label;
          dataForObj.rules[item.key] = "required";
        }

        // Init already configured data
        if (filterData) {
          for (let key in filterData) {
            dataForObj[key] = filterData[key];
            if (relationalFilters.includes(key)) {
              if (key === 'customer_uuid') {
                let tmpResponse = await CustomerService.getCustomer(dataForObj[key]);
                if (tmpResponse.success) {
                  dataForObj['customer'] = tmpResponse.body;
                }
              }
            }
          }
        }

        this.model = new ReportConfigurationModel(dataForObj);

        this.filters = filters;

        return true;
      },
      async onSubmit() {
        this.showConfirmation = false;
        this.loading = true;
        let response = await ReportsService.saveConfigurationData(this.report.uuid, this.model)
        this.loading = false;
        if (response.success) {
          this.$toast('success', this.$i18n.t("Configuration was successfully saved"))
          this.getReports()
          this.hideReportConfigurationModal()
        } else {
          this.showConfirmation = true;
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>
